import { Component, OnInit, Inject, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { AuthService } from '../shared/services/auth.service';
import { NotifyService } from '../shared/services/notify.service';
import { InventoryService } from './inventory.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { INotification } from '../shared/interfaces/notification';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.css']
})
export class InventoryComponent implements OnInit {


  inventory:any[] = [];
  showAddForm: boolean = false;
  showView: boolean = false;
  fForm: FormGroup;
  materials: any[] = [];
  suppliers: string[] = [];
  jobNames: string[] = [];
  customers: any[] = [];
  locations: any[] = [];
  inventoryTypes:string[] = [];
  slabTypes:string[] = [];
  colors:any[] = [];
  finishes:string[] = [];
  thicks:number[] = [];
  users:any[] = [];
  lshapes:string[] = [];
  statuses:string[] = [];
  fullCount:number = 0;
  partialCount:number = 0;
  search:string;
  showFilters: boolean = false;
  showScanner:boolean = false;
  showPO:boolean= false;
  showPrinter:boolean = false;
  editing:boolean = false;
  showOrder: boolean = false;
  searchList:string[] = [];
  perPage:number = 50;
  numPages:number = 0;
  currPage:number = 1;
  pages:number[] = [];
  currUser:any;
  printer$;

  private orderField = 'barcode';
  private orderDir = -1;

  constructor(
    private _ref: ChangeDetectorRef,
    private _aRef: ApplicationRef,
    @Inject(DOCUMENT) private document: any,
    @Inject(FormBuilder) fb: FormBuilder,
    private _appService: AppService,
    private _invService: InventoryService,
    private _notifyService: NotifyService,
    private _authService: AuthService
  ) {
    this._invService.showAddForm$.subscribe(
      show => {
        if(!show && this.editing) {
          this.editing = false;
          this.getInventory();
        }
        this.showAddForm = show
      }
    );

    this._invService.showOrderForm$.subscribe(
      show => this.showOrder = show
    );

    this._invService.rowReady$.subscribe(
      row => this.inventory.unshift(row)
    );

    this._invService.showView$.subscribe(
      v => this.showView = v
    );

    this._invService.barCode$.subscribe(
      b => {
        this.showScanner = false;
        this.showBarcodeDetail(b)
      }
    );

    this._invService.showScan$.subscribe(
      b => this.showScanner = b
    );

    this._appService.showPrintSelection$.subscribe(
      toShow => this.showPrinter = toShow
    );

    this._appService.invSelectedPrinter$.subscribe(
      data => {
        if (this._appService.getPrintFor() === 'inventory') {
          this.finalPrintBarcode(data)
        }
      }
    );

    this.fForm = fb.group({
      jobName: [null],
      jobNum: [null],
      barcode: [null],
      status:['Active'],
      po: [null],
      location: [null],
      slabType: [null],
      inventoryType: [null],
      material: [null],
      color: [null],
      finish: [null],
      lot: [null],
      lengthMin: [null],
      lengthMax: [null],
      thickness: [null],
      widthMin: [null],
      widthMax: [null],
      lShape: [null],
      lLengthMin: [null],
      lWidthMin: [null],
      lLengthMax: [null],
      lWidthMax: [null],
      supplier: [null],
      priceMin: [null],
      priceMax: [null],
      neededMin: [null],
      neededMax: [null],
      eDeliveryMin: [null],
      eDeliveryMax: [null],
      receivedMin: [null],
      receivedMax: [null],
      customer: [null],
      sawedBy: [null],
      cutMin: [null],
      cutMax: [null],
      cutSaw: [null],
      term: [null]
    });
  }

  ngOnInit() {

    this.currUser = this._authService.getUser();

    this.getInventory();

    this._invService.getLists().subscribe(
      data => {
        this.jobNames = data.lists.jobNames;
        this.searchList = this.jobNames;
        this.customers = data.lists.customers;
        this.suppliers = data.lists.suppliers;
        //this.suppliers.unshift({name:null});
        this.materials = data.lists.materials;
        //this.materials.unshift({name:null, colors:[]});
        this.materials.forEach( (m) => {
          this.searchList.push(m.name);
          m.colors.forEach( (c) => {
            this.searchList.push(c.name);
          })
          //m.colors.unshift({name:null});
        });
        this.locations = data.lists.locations;
        //this.locations.unshift({name:null});
        this.users = data.lists.users;
        //this.users.unshift({username:null});
      }
    );

    this.inventoryTypes = this._invService.getInventoryTypes();
    //this.inventoryTypes.unshift(null);
    this.slabTypes = this._invService.getSlabTypes();
    //this.slabTypes.unshift(null);
    this.finishes = this._invService.getFinishes();
    //this.finishes.unshift(null);
    this.thicks = this._invService.getThicks();
    //this.thicks.unshift(null);
    this.lshapes = this._invService.getLShapes();
    //this.lshapes.unshift(null);
    this.statuses = this._invService.getStatuses();

    this.fForm.reset();
  }

  edit(item) {
    this._appService.showLoader();
    this.showAdd();
    this.editing = true;
    setTimeout(() => {
      this._invService.setEditReady(item);
    }, 500);

  }

  getInventory() {

    this._appService.showLoader();
    let params = this.fForm.value;
    params.orderField = this.orderField;
    params.orderDir = this.orderDir;

    this._invService.getInventory(params).subscribe(
      data => {
        this.inventory = data.inventory;
        setTimeout(()=>{
          this._appService.hideLoader();
        },500);
        let f = 0;
        let p = 0;
        this.inventory.forEach(function (i) {
          if(i.slabType == 'Full') f++;
          if(i.slabType == 'Partial') p++;
        });
        this.fullCount = f;
        this.partialCount = p;
        this.numPages = Math.ceil(this.inventory.length / this.perPage);
        this.pages = [];
        for(let page = 1; page <= this.numPages; page++) {
          this.pages.push(page);
        }
        this.currPage = 1;
      }
    );
  }


  setColors() {
    var mat = this.fForm.get('material').value;
    for(let i = 0; i< this.materials.length; i++) {
      if(this.materials[i].name == mat) {
          this.colors = this.materials[i].colors.sort((a,b)=>{
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
          });
        //this.fForm.get('color').setValue(this.colors[0].name);
      }
    }
  }

  showDetail(item) {
    this.showView = true;
    this._appService.showLoader();
    setTimeout(() => {
      this._invService.viewItem(item);
      this._appService.hideLoader();
    }, 1000)

  }

  showBarcodeDetail(b) {
    this.fForm.reset();
    this.fForm.get('barcode').setValue(b);
    // this._appService.hideLoader();
    // let n:INotification = {
    //         styleClass:"alert-danger",
    //         heading: "No Results",
    //         body:"There is no inventory for the scanned barcode"
    //       };
    // this._notifyService.setNote(n);
    // this._invService.getDetail(b).subscribe(
    //   data => {
    //     this._aRef.tick();
    //     if(data.inventory) {
    //       console.log('foo');
    //       //this.showDetail(data.inventory);
    //     } else {
    //       console.log('bar');
    //       this._ref.detectChanges();
    //       this._appService.hideLoader();
    //     }
    //   }
    // );

  }


  showAdd() {
    this.showAddForm = true;
  }

  hideAdd() {
    this.showAddForm = false;
  }

  printBarcode(item) {
    this._appService.setPrintItem(item);
    this._appService.showPrintSelection("inventory");
  }

  finalPrintBarcode(data) {
    const item = this._appService.getPrintItem();
    this.showPrinter = false;
    this._appService.showLoader();
    this._invService.printLabel(item, data).subscribe(
      data => {
        this._appService.hideLoader();
      }
    );
  }

  closeJob(item) {
    this._appService.showLoader();
    this._invService.closeJob(item).subscribe(
      data => {
        this.getInventory();
      }
    );
  }

  openJob(item) {
    this._appService.showLoader();
    this._invService.reOpenJob(item).subscribe(
      data => {
        this.getInventory();
      }
    );
  }

  trash(item, i) {
    this._appService.showLoader();
    this._invService.trash(item).subscribe(
      data => {
        this.getInventory();
      }
    );
  }

  delete(item, i) {
    this._appService.showLoader();
    this._invService.delete(item).subscribe(
      data => {
        this.getInventory();
      }
    );
  }


  filterOnKey(event: any) {
    this.search = event.target.value;
  }

  resetFetch() {
    this.fForm.reset();
    this.fForm.get('status').setValue('Active');
    this.getInventory();
  }


  resetQ() {
    this.fForm.reset();
    this.fForm.get('status').setValue('Active');
  }

  changePerPage(event: any) {
    this.perPage = event.target.value;
    this.getInventory();
  }

  removeFromResults(i) {
    this.inventory.splice(i, 1);
  }

  displayPO() {
    this._appService.showLoader();
    this.showPO = true;
    setTimeout(() => {
      this._invService.setPOReady(this.inventory);
    }, 1000);

  }

  order() {
    this.showOrder = true;
  }

  setSortCol(col){
    if(this.orderField == col) {
      this.orderDir = this.orderDir*-1;
    } else {
      this.orderDir = 1;
    }
    this.orderField = col;
    this.getInventory();
  }

  export() {
    this._appService.showLoader();
    let params = this.fForm.value;
    this._invService.export(params).subscribe(
      data => {
        window.open(data.url);
        this._appService.hideLoader();
      }
    );
  }

  searchJobNames = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.jobNames.filter(job => new RegExp(term, 'gi').test(job)).splice(0, 10));

  searchCustomers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.customers.filter(c => new RegExp(term, 'gi').test(c)).splice(0, 10));

  searchSuppliers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.suppliers.filter(sup => new RegExp(term, 'gi').test(sup)).splice(0, 10));

  searchQuickList = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.searchList.filter(sup => new RegExp(term, 'gi').test(sup)).splice(0, 10));

  nextPage() {
    if(this.currPage < this.numPages) {
      this.currPage++;
    } else {
      this.currPage = 1;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

  prevPage() {
    if(this.currPage > 1) {
      this.currPage--;
    } else {
      this.currPage = this.numPages;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

  setPage(event:any) {
    const p = this.pages[event.target.selectedIndex];
    if(p != this.currPage) {
      this.currPage = p;
    }
    this.document.getElementById("scrollBody").scrollTop = 0;
  }

  toggleAdvanced() {
    this.showFilters = (this.showFilters)?false:true;
    if(this.showFilters) {
      this.fForm.get('term').setValue(null);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/inventory.component.ts